<template>
    <v-row class="white-card" align="center" dense>
        <v-col cols="12">
            <v-date-picker :events="sessionsDays" readonly color="#CCFF99" event-color="grey darken-1" locale="es-CL"
                first-day-of-week="1" full-width no-title :picker-date.sync="pickerDate" :show-current="false" />
        </v-col>
        <v-col cols="12">
            <doughnut-chart :title="$t('common.sessions')" :labels="labels" :datasets="datasets"
                style="height: 180px" />
            <div class="actual-sessions">
                {{ $t('common.actual_sessions') }}
                <span>{{ docs.length }}</span>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import DoughnutChart from '../common/DoughnutChart.vue'

export default {
    components: { DoughnutChart },
    name: "SessionsChart",
    props: {
        docs: {
            type: Array,
            default: null,
        },
        date: {
            type: String,
            default: null,
        }
    },
    data(vm) {
        return {
            datasets: [],
            labels: [vm.$t('common.completeds'), vm.$t('common.no_completeds')],
            colors: ['#5da219', '#fd2e00'],
            sessions: [],
            pickerDate: null,
        }
    },
    mounted() {
        const vm = this
        vm.loadStats()
    },
    methods: {
        loadStats() {
            const vm = this
            const noCompleteds = vm.docs.filter(({ advance }) => !advance?.post)
            const completeds = vm.docs.filter(({ advance }) => advance?.post)
            vm.datasets = [{
                data: [completeds.length, noCompleteds.length],
                backgroundColor: vm.colors
            }]
        },
        sessionsDays(date) {
            return this.docs
                .filter(({ rawDate }) => rawDate.full === date)
                .map(({ advance }) => (advance?.post ? this.colors[0] : this.colors[1]));
        },
    },
    watch: {
        docs() {
            this.loadStats()
        },
        date(val) {
            this.pickerDate = val
        }
    }
}
</script>

<style scoped>
.actual-sessions {
    text-align: center;
}

.actual-sessions span {
    font-weight: bold;
}

::v-deep .v-date-picker-table {
    height: 100%;
}
</style>